import { getBearerToken } from "../../../../api/postCall/bearerToken";
import {
  searchForMedicalPaOrdersFromPostgres,
  SearchForMedicalPaOrdersFromPostgresParams,
} from "../../../../api/postgreSQL/postCalls/searchForMedicalPaOrdersFromPostgres";
import { AuthStatusOptionModel } from "../../../../data-model/authStatusOptions";
import { PostgresResponseForMedicalPaOrders } from "../../../../data-model/postgresResponseForMedicalPaOrders";
import { MyMedicalPaOrdersTableData } from "../../../../data-model/tablesData";
import { MyMedicalPaOrdersState } from "../../myPaOrders/hooks/useMyPaOrdersTableData";
import { generateAllOpenOrdersTableData } from "../utils/generateTableDataFromAllOpenRecords";

/**
 * Fetches All Open Orders from Postgres using the given search payload, then updates
 * the orders state and table data. Resets pagination on completion.
 *
 * @param payload - Search parameters for the Postgres query
 * @param authStatusOptions - Available auth status options for badge rendering
 * @param setAllOpenOrdersState - State setter for the orders loading/data/error state
 * @param setTableData - State setter for the transformed table row data
 * @param setPaginationResetCount - Incremented to signal a pagination reset
 */
export const makePostCallForAllOpenOrders = async (
  payload: SearchForMedicalPaOrdersFromPostgresParams,
  authStatusOptions: AuthStatusOptionModel[],
  setAllOpenOrdersState: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersState>
  >,
  setTableData: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersTableData[]>
  >,
  setPaginationResetCount: React.Dispatch<React.SetStateAction<number>>,
) => {
  setAllOpenOrdersState((prev) => ({ ...prev, loading: true }));
  try {
    await getBearerToken();
    const response = await searchForMedicalPaOrdersFromPostgres(payload);
    const data = JSON.parse(response) as PostgresResponseForMedicalPaOrders;
    setAllOpenOrdersState((prev) => ({
      ...prev,
      data: data,
    }));
    setTableData(
      generateAllOpenOrdersTableData(data.hits ?? [], authStatusOptions),
    );
  } catch (error) {
    setAllOpenOrdersState((prev) => ({ ...prev, error: error as string }));
  } finally {
    setAllOpenOrdersState((prev) => ({ ...prev, loading: false }));
    setPaginationResetCount((prev) => prev + 1);
  }
};
